import React from 'react';
import { ArcButton, ArcStack } from '@src/core/ui';
import { useNavigate } from 'react-router-dom';
import { routesConfig } from '@src/core/routes';
import Sections from './status/sections';
import Popups from './status/popups';
import { useDispatch } from 'react-redux';
import { setSelectedOrder, setOrderFormData } from './redux';
import { ORDER_COLUMN_GRID_SX } from './constants';

const OrdersPage: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleCreateMission = () => {
    dispatch(setOrderFormData(null));
    navigate('create');
  };

  const handleTemplates = () => {
    navigate(routesConfig.missionTemplates);
  };

  React.useEffect(() => {
    return () => {
      dispatch(setSelectedOrder(null));
    };
  }, [dispatch]);

  return (
    <React.Fragment>
      <ArcStack flex={1} padding={2} marginTop={1} sx={{ height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <ArcStack sx={{ ...ORDER_COLUMN_GRID_SX, flexShrink: 0 }}>
          <ArcButton.brand
            size='large'
            fullWidth
            onClick={handleCreateMission}
          >
            CREATE MISSION
          </ArcButton.brand>
          <ArcButton.ghost
            size='large'
            fullWidth
            onClick={handleTemplates}
          >
            MISSION TEMPLATES
          </ArcButton.ghost>
        </ArcStack>

        <ArcStack sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
          <Sections />
        </ArcStack>

        <Popups />
      </ArcStack>
    </React.Fragment>
  );
};

export default OrdersPage;